import React, { ReactNode } from 'react';

import '../../base.css';

type Props = {
  children?: ReactNode;
};

const ModalFooter = ({ children }: Props) => {
  return <div styleName="modal-footer ">{children}</div>;
};

export default ModalFooter;
